const messages = {
  "title": "Dobrodošli u BRIDGESTONE <span class='text-danger'>PLUS</span>",
  "description": "<b>Već imate račun?</b><br/>Prijavite se s vašom email adresom i lozinkom.<br/><br/><b>Novi ovdje?</b><br/>Ako ste novi korisnik, molimo registrirajte se.<br/><br/>",
  "info": "",
  "buttons": {
    "action": "Prijavi se / Registriraj se",
    "back": "Natrag na prijavu",
    "changeLanguage": "Promijeni jezik",
    "start": "Počni"
  },
  "languageSelect": {
    "label": "Odabir jezika",
    "description": "Molimo odaberite vaš jezik"
  }
}

export default {
  messages
}